export var TimeStampModifiers;
(function (TimeStampModifiers) {
    TimeStampModifiers["modifierTime"] = "event-time";
    TimeStampModifiers["modifierScore"] = "event-score";
    TimeStampModifiers["modifierDatePeriod"] = "event-date";
    TimeStampModifiers["modifierLiveTime"] = "event-live-time";
})(TimeStampModifiers || (TimeStampModifiers = {}));
//# sourceMappingURL=TimeStampModifiers.js.map